import React from "react";

const ItemTable = ({
  formDetailList,
  handleChangeDetail,
  setFormDetailList,
  disabled,
}) => {
  const handleAddContactRow = () => {
    const newRow = {
      SetDefault: "N",
      Add1: "",
      Add2: "",
      Add3: "",
      Province: "",
      Zip_Code: "",
      Tel1: "",
      Tel2: "",
      Contact1: "",
      Contact2: "",
      Add_Status: "Y",
    };
    setFormDetailList((prev) => [...prev, newRow]);
  };

  const handleRemoveRow = (index) => {
    setFormDetailList((prev) => prev.filter((_, i) => i !== index));
  };

  const handleChangeDetailWithSetDefault = (index, field, value) => {
    setFormDetailList((prev) => {
      let updated = [...prev];

      if (field === "SetDefault" && value === "Y") {
        // แก้ให้แถวที่เลือกเป็น Y ที่เหลือเป็น N
        updated = updated.map((item, i) => ({
          ...item,
          SetDefault: i === index ? "Y" : "N",
        }));
      } else {
        updated[index][field] = value;
      }

      return updated;
    });
  };

  return (
    <div className="col-12">
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h4 className="card-title">รายละเอียดสถานที่จัดส่ง</h4>
          <div>
            <button
              className="btn btn-lg shadow text-white"
              style={{ backgroundColor: "#EF6C00" }}
              onClick={handleAddContactRow}
              type="button"
            >
              <i className="fa fa-map-marker"></i> เพิ่มสถานที่จัดส่ง
            </button>
          </div>
        </div>

        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-striped">
              <thead className="thead-dark">
                <tr>
                  <th className="text-center">#</th>
                  <th className="text-center">ที่อยู่ 1</th>
                  <th className="text-center">ที่อยู่ 2</th>
                  <th className="text-center">ที่อยู่ 3</th>
                  <th className="text-center">จังหวัด</th>
                  <th className="text-center">รหัสไปรษณีย์</th>
                  <th className="text-center">เบอร์โทร 1</th>
                  <th className="text-center">เบอร์โทร 2</th>
                  <th className="text-center">ผู้ติดต่อ 1</th>
                  <th className="text-center">ผู้ติดต่อ 2</th>
                  <th className="text-center">สถานะ</th>
                  <th className="text-center">ค่าเริ่มต้น</th>
                  <th className="text-center">ลบ</th>
                </tr>
              </thead>
              <tbody>
                {formDetailList.length > 0 ? (
                  formDetailList.map((item, index) => (
                    <tr key={index}>
                      <td className="text-center">{index + 1}</td>
                      <td>
                        <input
                          className="form-control"
                          value={item.Add1 || ""}
                          onChange={(e) =>
                            handleChangeDetailWithSetDefault(
                              index,
                              "Add1",
                              e.target.value
                            )
                          }
                          disabled={disabled}
                        />
                      </td>
                      <td>
                        <input
                          className="form-control"
                          value={item.Add2 || ""}
                          onChange={(e) =>
                            handleChangeDetailWithSetDefault(
                              index,
                              "Add2",
                              e.target.value
                            )
                          }
                          disabled={disabled}
                        />
                      </td>
                      <td>
                        <input
                          className="form-control"
                          value={item.Add3 || ""}
                          onChange={(e) =>
                            handleChangeDetailWithSetDefault(
                              index,
                              "Add3",
                              e.target.value
                            )
                          }
                          disabled={disabled}
                        />
                      </td>
                      <td>
                        <input
                          className="form-control"
                          value={item.Province || ""}
                          onChange={(e) =>
                            handleChangeDetailWithSetDefault(
                              index,
                              "Province",
                              e.target.value
                            )
                          }
                          disabled={disabled}
                        />
                      </td>
                      <td>
                        <input
                          className="form-control"
                          value={item.Zip_Code || ""}
                          onChange={(e) =>
                            handleChangeDetailWithSetDefault(
                              index,
                              "Zip_Code",
                              e.target.value
                            )
                          }
                          disabled={disabled}
                        />
                      </td>
                      <td>
                        <input
                          className="form-control"
                          value={item.Tel1 || ""}
                          onChange={(e) =>
                            handleChangeDetailWithSetDefault(
                              index,
                              "Tel1",
                              e.target.value
                            )
                          }
                          disabled={disabled}
                        />
                      </td>
                      <td>
                        <input
                          className="form-control"
                          value={item.Tel2 || ""}
                          onChange={(e) =>
                            handleChangeDetailWithSetDefault(
                              index,
                              "Tel2",
                              e.target.value
                            )
                          }
                          disabled={disabled}
                        />
                      </td>
                      <td>
                        <input
                          className="form-control"
                          value={item.Contact1 || ""}
                          onChange={(e) =>
                            handleChangeDetailWithSetDefault(
                              index,
                              "Contact1",
                              e.target.value
                            )
                          }
                          disabled={disabled}
                        />
                      </td>
                      <td>
                        <input
                          className="form-control"
                          value={item.Contact2 || ""}
                          onChange={(e) =>
                            handleChangeDetailWithSetDefault(
                              index,
                              "Contact2",
                              e.target.value
                            )
                          }
                          disabled={disabled}
                        />
                      </td>
                      <td>
                        <select
                          className="form-select"
                          value={item.Add_Status || "Y"}
                          onChange={(e) =>
                            handleChangeDetailWithSetDefault(
                              index,
                              "Add_Status",
                              e.target.value
                            )
                          }
                          disabled={disabled}
                        >
                          <option value="Y">ใช้งาน</option>
                          <option value="N">ไม่ใช้งาน</option>
                        </select>
                      </td>
                      <td>
                        <select
                          className="form-select"
                          value={item.SetDefault || "N"}
                          onChange={(e) =>
                            handleChangeDetailWithSetDefault(
                              index,
                              "SetDefault",
                              e.target.value
                            )
                          }
                          disabled={disabled}
                        >
                          <option value="Y">ใช่</option>
                          <option value="N">ไม่ใช่</option>
                        </select>
                      </td>
                      <td className="text-center">
                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() => handleRemoveRow(index)}
                          disabled={disabled}
                        >
                          ลบ
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="13">
                      <center>ไม่พบรายการ</center>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ItemTable;
